<div class="order-details-card">
  <div class="order-content">
    <div class="order-summary">
      <div class="order-summary-list">
        <div class="summary-item">
          <span>{{ 'components.orderContent.identifier' | i18n }}</span>
          <span class="value">{{ orderDetails.identifier }}</span>
        </div>
        <span class="separator"></span>
        <div class="order-summary-mobile">
          <div class="summary-item">
            <span>{{ 'components.orderContent.orderDate' | i18n }}</span>
            <span class="value">{{ orderDetails.createdAt | date: 'dd/MM/yyyy' }}</span>
          </div>
          @if (orderDetails.installationDate && hasUtmInUrl()) {
            <span class="separator separator-mobile"></span>
            <div class="summary-item">
              <span>{{ 'components.orderContent.installationDate' | i18n }}</span>
              <span class="value">{{ orderDetails.installationDate | date: 'dd/MM/yyyy' }}</span>
            </div>
          }
          <span class="separator separator-mobile"></span>
          <div class="summary-item">
            <span>{{ 'components.orderContent.total' | i18n }}</span>
            @if (orderDetails.total || displayProducts.length > 0) {
              <span class="value">{{ getTotalMonthlyPrice() | currencyBRL }}{{ getTotalMonthlySuffix() }}</span>
            }
          </div>
        </div>
      </div>
      <div [class]="'summary-item status status-badge-' + orderDetails.status">
        <umkt-icon [icon]="icon" size="sm"></umkt-icon>
        <span class="status-value">{{ status }}</span>
      </div>
    </div>

    <div class="product-list">
      @for (group of displayProductGroups; track group.groupTrackId) {
        <article class="product-row">
          <div class="product-info">
            @for (product of group.products; track product.displayTrackId; let isLast = $last) {
              <div
                class="product-info__main"
                [class.product-info__main--separated]="group.products.length > 1 && !isLast"
              >
                <div class="product-item">
                  <p class="product-name">{{ product.name }}</p>
                  <p class="product-details">
                    <span class="product-qty-badge">
                      {{ product.quantity }}{{ ' ' }}{{ ((product.quantity > 1) ? 'components.orderContent.signatures' : 'components.orderContent.signature') | i18n }}
                    </span>
                  </p>
                </div>
                <div class="product-value-wrap">
                  @if (isFreeProductPrice(product)) {
                    <span class="product-price-free-badge">{{ 'components.orderPanel.free' | i18n }}</span>
                  } @else if (getMindListPrice(product); as mindPromo) {
                    @if (mindPromo.hasPromotion) {
                      <div class="product-price-mind">
                        <span class="product-price-amount">
                          {{ mindPromo.displayPrice | currencyBRL }}/mês
                        </span>
                        <span class="product-price-mind__hint">
                          <span>{{ getMindPromoDurationKey(mindPromo) | i18n: { count: mindPromo.promotionMonths } }}</span>
                          <span>{{ 'components.productCard.promoAfterMonthly' | i18n: { price: formatMindOriginalPrice(mindPromo.originalPrice) } }}</span>
                        </span>
                      </div>
                    } @else {
                      <span class="product-price-amount">{{ mindPromo.displayPrice | currencyBRL }}</span>
                    }
                  } @else if (getMonthlySuffix(product); as priceSuffix) {
                    <div class="product-price-recurring">
                      <span class="product-price-amount">{{ getMonthlyPrice(product) | currencyBRL }}{{ priceSuffix }}</span>
                      <span class="product-price-unit">{{ 'components.orderContent.perSignature' | i18n }}</span>
                    </div>
                  } @else {
                    <span class="product-price-amount">{{ getMonthlyPrice(product) | currencyBRL }}</span>
                  }
                </div>
              </div>
            }
            @if (getGroupDomainPanelProduct(group); as domainSource) {
              @if (getVisibleRequiredFields(domainSource).length > 0) {
                <div class="required-fields-panel">
                  <p class="required-fields-panel__title">{{ 'components.orderContent.itemExtraDetails' | i18n }}</p>
                  <dl class="product-required-fields">
                    @for (field of getVisibleRequiredFields(domainSource); track trackRequiredField(field, $index)) {
                      <div class="required-field-pair">
                        <dt class="required-field-label">{{ getRequiredFieldDisplayLabel(field) }}</dt>
                        <dd class="required-field-value">
                          <span class="required-field-value__inline">
                            <span class="required-field-value__text">{{ getRequiredFieldDisplayValue(field) }}</span>
                            @if (isDomainValueField(field)) {
                              @if (getLineItemDomainPreference(domainSource); as domainPref) {
                                <span
                                  class="domain-pref-badge"
                                  [class.domain-pref-badge--new]="domainPref === 'new'"
                                  [class.domain-pref-badge--existing]="domainPref === 'existing'"
                                  [class.domain-pref-badge--transfer]="domainPref === 'transfer'"
                                >
                                  {{ ('components.orderContent.domainPreferenceBadge.' + domainPref) | i18n }}
                                </span>
                              }
                            }
                          </span>
                        </dd>
                      </div>
                    }
                  </dl>
                </div>
              }
            }
          </div>
        </article>
      }
    </div>

    @if (getInstallationAddressLine() && hasUtmInUrl()) {
      <div class="installation-address-block">
        <p class="installation-address-label">{{ 'components.orderContent.installationAddress' | i18n }}</p>
        <p class="installation-address-value">{{ getInstallationAddressLine() }}</p>
      </div>
    }

    <div class="payment-info">
      @if (orderDetails.card || orderDetails.total) {
        <p class="payment-title">{{ 'components.orderContent.paymentMethods' | i18n }}</p>
        <div class="payment-details">
          <p>{{ 'components.orderContent.processedOn' | i18n: { date: (orderDetails.createdAt | date: 'dd/MM/yyyy') || ''} }}</p>
          
          @if (orderDetails.card) {
            <div class="payment-method">
              <img [src]="iconBrandPath" [alt]="cardFlag + ' logo'" class="payment-icon" />
              <span>{{ 'components.orderContent.endingIn' | i18n: { digits: orderDetails.card.lastFourDigits } }}</span>
            </div>
          } @else if (orderDetails.flow === 'BOLETO_CARTAO') {
            <div class="payment-method">
              <img src="assets/images/billet.svg" alt="logo de boleto" class="payment-icon billet" />
              <span>{{ 'components.orderContent.paymentBoleto' | i18n }}</span>
            </div>
          } @else {
            <div class="payment-method">
              <span>{{ 'components.orderContent.paymentInvoice' | i18n }}</span>
            </div>
          }
          <strong>{{ getTotalMonthlyPrice() | currencyBRL }}{{ getTotalMonthlySuffix() }} </strong>
        </div>
      }
    </div>
  </div>
</div>